let BaseMediaSessionMonitor = function() { this.init.apply(this, arguments); };
BaseMediaSessionMonitor.prototype = {
  playCount: 0,
  updateInterval: 1000,
  timeSpanQueue: [],
  queueTimer: null,
  renderer: null,
  request_queue: null,

  init: function(userId, userType, media, renderer, parent = null) {
    this.request_queue = $({});
    this.userId = userId;
    this.userType = userType;
    this.media = media;
    this.renderer = renderer;
    this.parent = parent;
    this.startMonitoring();
  },

  onPlay: function () {
    this.media = this.getCurrentMedia();

    if(!this.media) return;

    this.playCount++;

    this.currentTimeSpan = new BaseMediaSessionMonitor.PlayTimeSpan(this.userId, this.getMediaId(this.media), this.userType);
    this.currentTimeSpan.start_time = this.renderer.currentTime();
    this.updateCurrentTimeSpan();

    // Only track the first play event per player
    if (this.playCount === 1) {
      Kadenze.Analytics.track('session_media', 'play', _.extend({}, this.media.tracking_data, { time_span: this.currentTimeSpan }));
    }
  },

  onSeeked: function(time) {
    console.log('seek called at ' + time);
    if (this.currentTimeSpan) {
      this.currentTimeSpan.end_time = this.renderer.currentTime();
      this.updateCurrentTimeSpan();
      this.addCurrentTimeSpanToQueue();
    }
  },

  onPauseOrEnded: function () {
    if (this.currentTimeSpan) {
      this.currentTimeSpan.end_time = this.renderer.currentTime();
      this.updateCurrentTimeSpan();
      this.addCurrentTimeSpanToQueue();
    }
  },

  onStopped: function (event) {
    if (this.currentTimeSpan) {
      this.currentTimeSpan.end_time = event.data.currentTime;
      this.currentTimeSpan.didReachEnd = event.data.ended;
      this.updateCurrentTimeSpan();
      this.addCurrentTimeSpanToQueue();
    }
  },

  onCaptionTrackChanged: function(event) {
    if (this.media)
      Kadenze.Analytics.track('session_media', 'caption_selected', _.extend({}, this.media.tracking_data, {lang: event.target.getCaptionLanguage() }));
    this.updateCurrentTimeSpan();
    this.addCurrentTimeSpanToQueue();
  },

  updateCurrentTimeSpan: function() {
    if(this.currentTimeSpan) {
      this.currentTimeSpan.playback_rate = this.renderer.playbackRate();

      if(this.renderer.isA(Kadenze.VideoPlayer)) {
        this.currentTimeSpan.resolution = this.renderer.resolution();
        this.currentTimeSpan.volume = this.renderer.volume();
        this.currentTimeSpan.textTrackSettings = this.renderer.getTextTrackSettings();
        this.currentTimeSpan.caption_language = this.renderer.getCaptionLanguage();
      }

      this.currentTimeSpan.viewing_time = this.currentTimeSpan.end_time - this.currentTimeSpan.start_time;
      this.currentTimeSpan.didReachEnd = this.renderer.ended();
    }
  },

  addCurrentTimeSpanToQueue: function () {
    this.timeSpanQueue.push(this.currentTimeSpan);
  },

  processQueue: function(doneCallback) {
    let timeSpan = null, media = this.media;

    while (timeSpan = this.timeSpanQueue.pop()) {
      if (timeSpan.viewing_time > 0) {
        console.log('Play Time Report: ' + JSON.stringify(timeSpan));

        this.updateUserState(timeSpan);
        this.renderer.updateUserState(timeSpan);
        if (media && timeSpan.didReachEnd) {
          Kadenze.Analytics.track('session_media', 'watched', _.extend({}, media.tracking_data, { time_span: timeSpan }));
        }
      }

      if (this.timeSpanQueue.length === 0) {
        doneCallback && doneCallback();
      }
    }
  },

  updateUserState: function(data) {
    //If this media has already been watched once, don't overwrite the userstate
    if (this.media && this.media.user_state_data && this.media.user_state_data.didReachEnd && this.media.user_state_data.didReachEnd())
      return;

    this.request_queue.queue(() => {
      const request = new Kadenze.AjaxRequest({
        type: 'POST',
        url: Kadenze.Routes.user_states_path(),
        data: { user_state: { stateable_id: data.media_id, stateable_type: 'LectureMedium', data: JSON.stringify(data) }}
      });
      request.success(() => {
        this.request_queue.dequeue();
      });
    });
  },

  getCurrentMedia: function() {
    return this.media;
  },

  getRenderer: function() {
    return this.renderer;
  },

  getMediaId: function(media) {
    return _.isFunction(media.id) ? media.id() : media.id;
  },

  //starts reporting data to server
  startMonitoring: function () {
    this.renderer = this.getRenderer();

    if(!this.renderer) return;

    this.renderer.addEventListener('playing', this.onPlay.bind(this));
    this.renderer.addEventListener('seeked', this.onSeeked.bind(this));
    this.renderer.addEventListener('pause', this.onPauseOrEnded.bind(this));
    this.renderer.addEventListener('ended', this.onPauseOrEnded.bind(this));
    this.renderer.addEventListener('stop', this.onStopped.bind(this));
    this.renderer.addEventListener('captionstrackchange', this.onCaptionTrackChanged.bind(this));

    //start queue
    this.queueTimer = setInterval(this.processQueue.bind(this), this.updateInterval);
  },

  //stops reporting data to server
  stopMonitoring: function () {
    this.renderer = this.getRenderer();

    if(!this.renderer) return;

    this.renderer.removeEventListener('playing', this.onPlay);
    this.renderer.addEventListener('seeked', this.onSeeked);
    this.renderer.removeEventListener('pause', this.onPauseOrEnded);
    this.renderer.removeEventListener('ended', this.onPauseOrEnded);
    this.renderer.removeEventListener('stop', this.onStopped);
    this.renderer.addEventListener('captionstrackchange', this.onCaptionTrackChanged);

    //stop queue
    clearInterval(this.queueTimer);
    this.queueTimer = null;
  },

  error: function(message) {
    console.error('Kadenze.MediaSessionMonitor: ', message);
  },

  warn: function(message) {
    console.warn('Kadenze.MediaSessionMonitor: ', message);
  },

  log: function(message) {
    console.log('Kadenze.MediaSessionMonitor: ', message);
  }

};

BaseMediaSessionMonitor.PlayTimeSpan = function (user_id, media_id, user_type) {
  this.date_stamp = new Date();
  this.user_id = user_id;
  this.media_id = media_id;
  this.start_time = -1;
  this.end_time = -1;
  this.viewing_time = -1;
  this.playback_rate = -1;
  this.didReachEnd = false;
  this.user_type = user_type;
};

BaseMediaSessionMonitor.ViewEvent = function(user_id, media_id) {
  this.date_stamp = new Date();
  this.user_id = user_id;
  this.media_id = media_id;
  this.hasViewed = false;
};

export default BaseMediaSessionMonitor;
